import markerclusterer_Image1 from '../../assets/images/ic_store_markercluster1.png';
import markerclusterer_Image2 from '../../assets/images/ic_store_markercluster2.png';
import markerclusterer_Image3 from '../../assets/images/ic_store_markercluster3.png';
import markerclusterer_Image4 from '../../assets/images/ic_store_markercluster4.png';
import markerclusterer_Image5 from '../../assets/images/ic_store_markercluster5.png';
import {Cluster} from "@googlemaps/markerclusterer/dist/cluster";
import {DefaultRenderer} from "@googlemaps/markerclusterer";
import {markerController} from "./marker";

export class CustomRenderer implements DefaultRenderer {
  private getImageAndSize(count: number): { image: string, size: number } {
    let image = ''
    let size = 0

    if (count >= 2 && count < 10) {
      image = markerclusterer_Image1
      size = 30
    } else if (count >= 10 && count < 50) {
      image = markerclusterer_Image2
      size = 40
    } else if (count >= 50 && count < 100) {
      image = markerclusterer_Image3
      size = 50
    } else if (count >= 100 && count < 200) {
      image = markerclusterer_Image4
      size = 60
    } else if (count >= 200) {
      image = markerclusterer_Image5
      size = 80
    }
    return {image, size}
  }

  render({count, position}: Cluster): google.maps.marker.AdvancedMarkerElement {
    const {image, size} = this.getImageAndSize(count)
    return new google.maps.marker.AdvancedMarkerElement({
      position: position,
      content: markerController.createMarkerContent(image, size, count),
      zIndex: count
    })
  }
}
